module.exports = __webpack_public_path__ + "img/defaultOrgBanner.8bd6aa47.png";